// Client mirror of functions-common/src/charts/datasets/daily.ts. Keep in sync.

import type { DatasetDefinition } from '../../types/chart.js'

export const dailyDataset: DatasetDefinition = {
  key: 'daily',
  labelKey: 'NLSChartDatasetDaily',
  fields: [
    { name: 'boardId', labelKey: 'NLSChartFieldBoardId', kind: 'dimension', type: 'string' },
    { name: 'openItems', labelKey: 'NLSChartFieldOpenItems', kind: 'measure', type: 'number' },
    { name: 'overdueItems', labelKey: 'NLSChartFieldOverdueItems', kind: 'measure', type: 'number' },
    { name: 'doneToday', labelKey: 'NLSChartFieldDoneToday', kind: 'measure', type: 'number' },
    { name: 'itemsCreated', labelKey: 'NLSChartFieldItemsCreated', kind: 'measure', type: 'number' },
    { name: 'goalProgressAvg', labelKey: 'NLSChartFieldGoalProgressAvg', kind: 'measure', type: 'number' },
    { name: 'budgetSpentToDate', labelKey: 'NLSChartFieldBudgetSpentToDate', kind: 'measure', type: 'number' },
    { name: 'stockValue', labelKey: 'NLSChartFieldStockValue', kind: 'measure', type: 'number' },
    { name: 'lowStockItems', labelKey: 'NLSChartFieldLowStockItems', kind: 'measure', type: 'number' },
    { name: 'responsesToday', labelKey: 'NLSChartFieldResponsesToday', kind: 'measure', type: 'number' },
    { name: 'proofsPending', labelKey: 'NLSChartFieldProofsPending', kind: 'measure', type: 'number' },
    { name: 'day', labelKey: 'NLSChartFieldDay', kind: 'time', type: 'date' },
  ],
  defaultMeasure: { field: 'openItems', agg: 'sum' },
  defaultTimeField: 'day',
  allowedRoles: ['OWNER', 'ADMIN', 'EDITOR', 'VIEWER', 'HELPER'],
  available: true,
}
